// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__9dqGg","imageWrapper":"index_imageWrapper__qp1wR","date":"index_date__xvcNW","img":"index_img__E5kNS","checkbox":"index_checkbox__xb4vv"};